// extracted by mini-css-extract-plugin
export default {"container":"AssetSubTypeForm_container__HOG3-","textWrapper":"AssetSubTypeForm_textWrapper__phm7t","boldText":"AssetSubTypeForm_boldText__4iXiI"};